import { escapeRegExp, trimEnd, upperFirst } from 'lodash-es';

const leadingNumberRegExp = /(^\d)/;
const nonWordOrWhitespace = /\W|\s/g;
const isoDateTimeStrRegExp =
  /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:(?:\.\d{3,6})?Z|[+-][01]\d:[0-5]\d)$/;

export function capitalizeFirstLetter(str: string) {
  return upperFirst(str);
}

export function removeTrailingSlashes(str: string) {
  return trimEnd(str, '/');
}

export function toIdString(str: string | undefined) {
  if (typeof str === 'undefined' || str === '') {
    return `id-${Math.random().toString().substring(2)}`;
  }

  return str.replace(leadingNumberRegExp, 'id-$1').replace(nonWordOrWhitespace, '-');
}

export function toRegExpSafeString(str: string) {
  return escapeRegExp(str);
}

export function isDateTimeString(str: string) {
  return typeof str === 'string' && isoDateTimeStrRegExp.test(str);
}

export function isNullOrEmpty(str: string | null) {
  return str === null || str === '';
}
